import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';

export class PaymentHistDetail extends TrackableEntity {
    id: number = 0;
    hdId: number = 0;
    seqNo: number = 0;
    status: string = '';
    branch: string = '';
    invoiceDate: string | null = null;
    invoiceNo: string = '';
    accountCode: string = '';
    description: string = '';
    amount: number = 0;
    customer: string = '';
    originalId: number = 0;
    depoDetailId: number = 0;
    customerId: number = 0;
    tbId: number = 0;
    tbName: string = '';

    constructor(init?:Partial<PaymentHistDetail>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'customer');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return PaymentHistDetail.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_PAYHISTORYDETAIL' }),
        'hdId': new DBMappingInfo({ field: 'F_HDID', table: 'T_PAYHISTORYDETAIL' }),
        'status': new DBMappingInfo({ field: 'F_Status', table: 'T_PAYHISTORYDETAIL' }),
        'invoiceDate': new DBMappingInfo({ field: 'F_InvoiceDate', table: 'T_PAYHISTORYDETAIL' }),
        'invoiceNo': new DBMappingInfo({ field: 'F_InvoiceNo', table: 'T_PAYHISTORYDETAIL' }),
        'accountCode': new DBMappingInfo({ field: 'F_GLNo', table: 'T_PAYHISTORYDETAIL' }),
        'description': new DBMappingInfo({ field: 'F_Description', table: 'T_PAYHISTORYDETAIL' }),
        'amount': new DBMappingInfo({ field: 'F_Amount', table: 'T_PAYHISTORYDETAIL' }),
        'originalId': new DBMappingInfo({ field: 'F_OriginalID', table: 'T_PAYHISTORYDETAIL' }),
        'depoDetailId': new DBMappingInfo({ field: 'F_DepoDetailID', table: 'T_PAYHISTORYDETAIL' }),
        'customerId': new DBMappingInfo({ field: 'F_CustomerID', table: 'T_PAYHISTORYDETAIL' }),
        'branch': new DBMappingInfo({ field: 'F_Branch', table: 'T_PAYHISTORYDETAIL' }),
        'tbName': new DBMappingInfo({ field: 'F_TBName', table: 'T_PAYHISTORYDETAIL' }),
        'tbId': new DBMappingInfo({ field: 'F_TBID', table: 'T_PAYHISTORYDETAIL' }),

    };
}
